// extracted by mini-css-extract-plugin
export default {"PopoverContent":"📚19-10-2X9Gka"};